export const DASHBOARD_PATH = '/dashboard'

/**
 * Every authenticated account starts on the dashboard, including accounts
 * without groups. Connecting a group is an action from the dashboard, not a gate.
 */
export function resolvePostLoginPath() {
  return DASHBOARD_PATH
}
